import React, { Fragment, useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from 'components/ui/popover';
import { CommonIcons } from 'components/Icons';
import { Button } from 'components/ui/button';
import { Separator } from 'components/ui/separator';
import { cn } from 'library/utils';

const ButtonDropdownComponent = (props) => {
  const {
    title,
    listDropDownItem = [],
    className,
    classNameDropdownMenu,
    disabled,
    color = 'primary',
    variant,
  } = props;
  const [dropdownOpen, setOpen] = useState(false);

  return (
    <Popover open={dropdownOpen} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          disabled={disabled}
          className={cn('tw-block', className)}
          variant={variant}
          color={color}
        >
          {title}{' '}
          <CommonIcons.ArrowDown className='tw-inline-block !tw-mr-0 tw-ml-1 tw-translate-y-[1px]' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn('tw-flex tw-flex-col tw-max-w-max', classNameDropdownMenu)}>
        {listDropDownItem.map((el, index) => (
          <Fragment key={`${index}`}>
            <Button
              key={`${index}`}
              disabled={el.disabled}
              onClick={() => {
                setOpen(false);
                el.onClick && el.onClick();
              }}
              variant='ghost'
              className={cn(
                'hover:tw-rounded-none hover:tw-cursor-pointer hover:tw-bg-slate-200 dark:hover:tw-text-black !tw-justify-start',
                el.className,
              )}
            >
              {el.name}
            </Button>
            {el.divider && <Separator className='tw-my-1' />}
          </Fragment>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default React.memo(ButtonDropdownComponent);
